import script from "./MineReviewIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MineReviewIndex.vue?vue&type=script&setup=true&lang=js"

import "./MineReviewIndex.vue?vue&type=style&index=0&id=5afeaee8&lang=css"
import "./MineReviewIndex.vue?vue&type=style&index=1&id=5afeaee8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5afeaee8"]])

export default __exports__